const Spotify = () => {
 return (
    <iframe title="Spotify Embed" style={{borderRadius:"12px", maxWidth: "300px"}} src="https://open.spotify.com/embed/playlist/0BOVJm7kD9UHv1ue8Qv9xr?utm_source=generator&theme=0" width="100%" height="490" frameBorder="0" allowfullscreen="" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>
 )
}

export default Spotify;